import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AgrAppModule } from '@next/core-lib/app';
import {
  AgrPageSidesheetModule,
  AgrPageToolbarModule,
  AgrPrimaryActionModule,
} from '@next/core-lib/components';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ControlRoomModule } from './control-room/control-room.module';
import { NitrogenModelPropertiesModule } from './nitrogen-model-properties/nitrogen-model-properties.module';
import { NutrientPropertiesModule } from './nutrient-properties/nutrient-properties.module';
import { OverviewModule } from './overview/overview.module';
import { ProductionPurposeCategoryModule } from './production-purpose-category/production-purpose-category.module';
import { SharedModule } from './shared/shared.module';
import { TemplateModule } from './template/template.module';

import { VarietyPropertiesModule } from './variety-properties/variety-properties.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    OverviewModule,
    TemplateModule,
    ControlRoomModule,
    NutrientPropertiesModule,
    VarietyPropertiesModule,
    NitrogenModelPropertiesModule,
    ProductionPurposeCategoryModule,
    AppRoutingModule,
    AgrAppModule,
    AgrWrapperSiteSidenavModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatToolbarModule,
    ReactiveFormsModule,
    AgrPageSidesheetModule,
    AgrPageToolbarModule,
    AgrPrimaryActionModule,
  ],
})
export class AppModule {}
